let $videoCards = $( '.on-demand-video-block' );
let $videoModal = $( '#video-overlay' );
let $iframe = $videoModal.find( 'iframe' );
let $closeBtn = $videoModal.find( '.close-btn' );
let $mask = $( '#video-overlay-mask' );

$( document ).ready( function() {
	//hack: move the mask and modal containers to the body
	$( 'body' ).append( $mask ).append( $videoModal );
} );

$videoCards.on( 'click', function( e ) {
	let $this = $( this );
	let src = $this.data( 'src' );

	$iframe.attr( 'src', src );
	$mask.fadeIn( 'fast' );
	$videoModal.fadeIn( 'fast' );
	$closeBtn.focus();
} );

$mask.on( 'click', function( e ) {
	closeVideoModal();
} );

$closeBtn.on( 'click', function() {
	closeVideoModal();
} );

function closeVideoModal() {
	$iframe.attr( 'src', '' );
	$videoModal.fadeOut( 'fast' );
	$mask.fadeOut( 'fast' );
}